import Phaser from "phaser";
import { ArtLabScene } from "../scenes/art-lab-scene";
import { BootScene } from "../scenes/boot-scene";
import { DropfrontScene } from "../scenes/dropfront-scene";
import { DropfrontSelectScene } from "../scenes/dropfront-select-scene";
import { FrontlineScene } from "../scenes/frontline-scene";
import { PortalFfaScene } from "../scenes/portal-ffa-scene";
import { RaidBattleScene } from "../scenes/raid-battle-scene";
import { RaidHubScene } from "../scenes/raid-hub-scene";
import { RaidRosterScene } from "../scenes/raid-roster-scene";
import { RaidSimScene } from "../scenes/raid-sim-scene";
import { NoiseExtractionScene } from "../scenes/noise-extraction-scene";
import { TitleScene } from "../scenes/title-scene";
import { InfiniteWarScene } from "../scenes/infinite-war-scene";

export const gameConfig: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: "game",
  width: 540,
  height: 960,
  backgroundColor: "#111b28",
  pixelArt: true,
  antialias: false,
  roundPixels: true,
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    parent: "game",
    expandParent: false,
  },
  scene: [
    BootScene,
    TitleScene,
    FrontlineScene,
    PortalFfaScene,
    DropfrontSelectScene,
    DropfrontScene,
    RaidHubScene,
    RaidSimScene,
    RaidRosterScene,
    RaidBattleScene,
    NoiseExtractionScene,
    InfiniteWarScene,
    ArtLabScene,
  ],
};